module.exports = __webpack_public_path__ + "img/process_map.f0479fc0.png";